<template>
  <v-container fluid class="height-100">
    <v-card class="box-shadow mine height-100">
      <v-card-text class="pa-0 height-100">
        <v-card class="height-100 text-center px-6 ml-16 box-shadow d-inline-block" tile max-width="480">
          <v-badge class="mt-16" bordered bottom :color="entity.sex | dict('男:blue/女:red')" dot offset-x="16" offset-y="16">
            <v-avatar size="80">
              <img :src="entity.avatar || '/assets/img/user-avatar.png'" :alt="entity.citizenName" />
            </v-avatar>
          </v-badge>
          <h3 class="mt-3">{{ entity.citizenName }}</h3>
          <p class="grey--text my-2">{{ entity.citizenId | idcard }}</p>
          <v-subheader class="text-center d-inline-block px-8 grey--text">{{ entity.uniName }}</v-subheader>
          <v-row class="text-left">
            <v-col cols="12" md="6" class="pr-2">
              <div class="rounded-lg pl-4 py-4" :class="$vuetify.theme.dark ? 'phone_dark' : 'phone'">
                <span>手机号码</span>
                <p class="title mb-0" :class="$vuetify.theme.dark ? '' : 'black--text'">{{ entity.telephone }}</p>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
              <div class="rounded-lg pl-4 py-4" :class="$vuetify.theme.dark ? 'post_dark' : 'post'">
                <span>职位</span>
                <p class="title mb-0" :class="$vuetify.theme.dark ? '' : 'black--text'">{{ entity.postName ? entity.postName : "暂无" }}</p>
              </div>
            </v-col>
          </v-row>
          <v-list class="text-left">
            <v-list-item class="mt-3 rounded" :class="$vuetify.theme.dark ? '' : 'list_shadow'">
              <v-list-item-avatar tile class="bg1"> </v-list-item-avatar>
              <v-list-item-content>
                <p class="caption grey--text">出生日期</p>
                <v-list-item-subtitle :class="$vuetify.theme.dark ? ' white--text' : 'black--text'">{{ entity.birth }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- 
            <v-list-item class="mt-3 rounded" :class="$vuetify.theme.dark ? '' : 'list_shadow'">
              <v-list-item-avatar tile class="bg2"> </v-list-item-avatar>
              <v-list-item-content>
                <p class="caption grey--text">联系电话</p>
                <v-list-item-subtitle :class="$vuetify.theme.dark ? ' white--text' : 'black--text'">{{ entity.subtitle }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item> 
            -->
            <v-list-item class="mt-3 rounded" :class="$vuetify.theme.dark ? '' : 'list_shadow'">
              <v-list-item-avatar tile class="bg3"> </v-list-item-avatar>
              <v-list-item-content>
                <p class="caption grey--text">现在住址</p>
                <v-list-item-subtitle :class="$vuetify.theme.dark ? ' white--text' : 'black--text'">{{ entity.address }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-row class="pt-4">
          <!-- 
            <v-col cols="12" md="12" class="grey--text">{{entity.description}}</v-col> 
          -->
          <!-- 
          <v-col cols="12" md="3"> </v-col>
          <v-col cols="12" md="3" class=""><v-btn icon color="green"><v-icon>mdi-email-newsletter</v-icon></v-btn></v-col>
          <v-col cols="12" md="3"><v-btn icon color="deep-orange"><v-icon>mdi-state-machine</v-icon></v-btn></v-col>
          <v-spacer /> 
          -->
          </v-row>
          <!-- <v-btn class="primary mt-8 px-10" elevation="0"><v-icon>mdi-account-edit-outline</v-icon> 编辑信息</v-btn> -->
        </v-card>
        <!-- <v-card class=" d-inline-block v-align-top" max-width="480">97869</v-card> -->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Request from "@/commons/request";
import Storage from "@/commons/storage";
import Validation from "@/commons/validation";
export default {
  name:"DashMine",
  data() {
    return {
      user: {},
      url: {
        list: "view/apps/page",
      },
      entity: {},
    };
  },
  mounted() {
    this.user = Storage.get("_wit_acis_users");
    this.view();
  },
  methods: {
    //资质详情
    view() {
      Request.postForm("/view/vmain/mine", this.userCreate).then((res) => {
        this.entity = res.data.user;
        let card = Validation.getFromIdCard(res.data.user.citizenId);
        this.entity.area = card.area;
        this.entity.birth = card.birth;
        this.entity.age = card.age;
        this.entity.sex = card.sex;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mine::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(../../assets/img/mine_bg.jpg);
  background-size: cover;
  opacity: 0.2;
}
.border-dashed {
  border: 1px #2196f3 dashed;
}
.border-solid {
  border: 1px rgba(182, 182, 182, 0.6) solid !important;
}
.phone {
  background: url(../../assets/img/phone.png) rgb(241, 241, 241) bottom right no-repeat;
  background-size: 80px;
}
.phone_dark {
  background: url(../../assets/img/phone.png) rgb(56, 56, 56) bottom right no-repeat;
  background-size: 80px;
}
.post {
  background: url(../../assets/img/portal3.png) rgb(241, 241, 241) bottom right no-repeat;
  background-size: 80px;
}
.post_dark {
  background: url(../../assets/img/portal3.png) rgb(56, 56, 56) bottom right no-repeat;
  background-size: 80px;
}
.bg1 {
  background: url(../../assets/img/mine_sr.png) no-repeat;
  background-size: cover;
}
.bg2 {
  background: url(../../assets/img/mine_dh.png) no-repeat;
  background-size: cover;
}
.bg3 {
  background: url(../../assets/img/mine_dz.png) no-repeat;
  background-size: cover;
}
.list_shadow {
  box-shadow: 0px 0px 5px #cccccc8a;
}
</style>